import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { withAuth } from "../api/msal/MsalAuthProvider";
import Header from "./common/header";
import ManagementUnits from "./managementMaintenance/ManagementMaintenance";
import Catalog from "./catalog/Catalog";
import Settings from "./settings/Settings";
import SpinnerCircle from "../components/common/Spinner";
import SpinnerFull from "../components/common/SpinnerFull";
import LoginError from "../components/common/login-error";
import MyProvider from "../api/context/my-provider";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

class RootApp extends Component {
  render() {
    return (
      <MyProvider>
        <BrowserRouter>
          <SpinnerCircle />
          <div className="pl-5 pr-5 pt-3">
            <SpinnerFull />
            <LoginError />
            <ToastContainer
                position={"bottom-left"}
                limit={1}
            />
            <Header {...this.props} />
            <Switch>
              <Route exact path="/" component={ManagementUnits} />

              {/*****BEGIN ---MANAGEMENT, MAINTENANCE ROUTE COMPONENT--- BEGIN*****/}
              <Route
                path="/management-maintenance"
                component={ManagementUnits}
              />

              {/*****END ---MANAGEMENT, MAINTENANCE ROUTE COMPONENT--- END*****/}

              {/*****BEGIN ---CATALOG ROUTE COMPONENT--- BEGIN*****/}
              <Route path="/catalog" component={Catalog} />
              <Route path="/catalog/management-units" component={Catalog} />
              <Route path="/catalog/discipline" component={Catalog} />
              <Route path="/catalog/measures" component={Catalog} />
              <Route path="/catalog/work-plans" component={Catalog} />
              <Route path="/catalog/work-resources" component={Catalog} />
              {/*****END ---CATALOG ROUTE COMPONENT--- END*****/}

              {/* werkregels */}
              <Route path="/settings" component={Settings} />
            </Switch>
          </div>
        </BrowserRouter>
      </MyProvider>
    );
  }
}
export const App = withAuth(RootApp);

// function App() {
//   return (
//     <MyProvider>
//       <BrowserRouter>
//         <SpinnerCircle />
//         <div className="pl-5 pr-5 pt-3">
//           <SpinnerFull />
//           <LoginError />
//           <Header {...this.props} />
//           <Switch>
//             <Route exact path="/" component={ManagementUnits} />

//             {/*****BEGIN ---MANAGEMENT, MAINTENANCE ROUTE COMPONENT--- BEGIN*****/}
//             <Route path="/management-maintenance" component={ManagementUnits} />
//             {/* <Route
//               path="/management-maintenance/management-units"
//               component={ManagementUnits}
//             />
//             <Route
//               path="/management-maintenance/measures"
//               component={ManagementUnits}
//             />
//             <Route
//               path="/management-maintenance/schedule"
//               component={ManagementUnits}
//             />
//             <Route
//               path="/management-maintenance/work-plans"
//               component={ManagementUnits}
//             />
//              <Route
//               path="/management-maintenance/workorder"
//               component={ManagementUnits}
//             />
//             <Route
//               path="/management-maintenance/budget"
//               component={ManagementUnits}
//             />
//             <Route
//               path="/management-maintenance/performance"
//               component={ManagementUnits}
//             /> */}

//             {/*****END ---MANAGEMENT, MAINTENANCE ROUTE COMPONENT--- END*****/}

//             {/*****BEGIN ---CATALOG ROUTE COMPONENT--- BEGIN*****/}
//             <Route path="/catalog" component={Catalog} />
//             <Route path="/catalog/management-units" component={Catalog} />
//             <Route path="/catalog/discipline" component={Catalog} />
//             <Route path="/catalog/measures" component={Catalog} />
//             <Route path="/catalog/work-plans" component={Catalog} />
//             <Route path="/catalog/work-resources" component={Catalog} />
//             {/*****END ---CATALOG ROUTE COMPONENT--- END*****/}

//             {/* werkregels */}
//             <Route path="/settings" component={Settings} />
//           </Switch>
//         </div>
//       </BrowserRouter>
//     </MyProvider>
//   );
// }
// export default withAuth(App);
